import Link from 'next/link'

import useKva, { LANDING_PAGE_LENDING } from '@/hooks/useKVA'

export default function Banner({ loanApplyUrl }) {
  const { addEventAction } = useKva()
  const onClickBannerRegisterButton = () => {
    addEventAction(LANDING_PAGE_LENDING, 'click_button_social_proof')
  }
  return (
    <div className="my-8 flex justify-center  ">
      <div className="max-w-[1920px]">
        <div className="flex flex-col  md:items-end items-center lg:h-[388px] md:h-[228px] h-[414px] lg:gap-14 gap-10 md:bg-banner-background bg-banner-background-mobile bg-cover lg:py-[64px] lg:pr-[104px] md:py-[31px] md:pr-[61px] pt-7 max-md:px-4 rounded-2xl lg:w-[1200px] md:w-[704px] w-[343px]">
          <div className="flex  flex-col lg:gap-8 gap-[19px] ">
            <h2 className="lg:w-[482px] w-[283px] lg:text-[30px] lg:leading-9 lg:font-bold !text-lg !font-semibold leading-[26px] text-navy">
              KiotViet đồng hành và phát triển cùng doanh nghiệp vừa và nhỏ
            </h2>
            <div className="flex gap-8">
              <div className="flex flex-col gap-1">
                <div className="lg:text-[30px] lg:leading-6 lg:font-bold text-lg font-semibold leading-[26px] text-brand-primary-500">
                  1.900 +
                </div>
                <div className="text-brand-navy lg:text-base font-normal text-[10px] leading-3">
                  Khách hàng đã vay
                </div>
              </div>
              <div className="flex flex-col gap-1">
                <div className="lg:text-[30px] lg:leading-6 lg:font-bold text-lg font-semibold leading-[26px] text-brand-primary-500">
                  324 tỷ +
                </div>
                <div className="text-brand-navy lg:text-base font-normal text-[10px] leading-3">
                  đã được giải ngân
                </div>
              </div>
            </div>

            <Link
              id="social-proof-register-button"
              className="
                  lg:h-[60px] h-9
                  lg:px-8 lg:py-[17px] px-4 py-2
                  shadow-register-button w-fit  bg-brand-primary-500 hover:bg-brand-primary-600 active:bg-brand-primary-700 rounded-[99px] justify-center items-center gap-2 inline-flex cursor-pointer
                  lg:text-xl text-sm font-semibold
                  font-[Inter] text-white md:leading-[27px] leading-5 text-center text-decoration-none	
                "
              onClick={onClickBannerRegisterButton}
              target="_blank"
              href={loanApplyUrl || '#'}
            >
              Đăng ký vay
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
